module.exports = __webpack_public_path__ + "static/media/1.4be23977.png";